module.exports = __webpack_public_path__ + "appstore/static/img/level0.6d6d92c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/level0.png
// module id = cGsb
// module chunks = 0